import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M20.164 4.298a1.87 1.87 0 0 0-1.866-1.862H5.328a1.857 1.857 0 0 0-1.866 1.862V7.7s0 8.356 1.038 11.3 19.5 3 15.837-3.292c-1.844-3.165-7.85 1.967.7 5.292"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M18.632 19.794c-4.815-3.192.074-6.886 1.705-4.086 1.118 1.92.175 3.25-1.705 4.086m0 0c.628.415 1.42.823 2.406 1.206m-2.406-1.206c-1.48.658-3.54 1.01-5.632 1.105"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M9 12.59h3.954a3.295 3.295 0 1 0 0-6.59H9M9 17.203V6"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const ParkingIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
